import { QUOTATION_RECEIVE, QUOTATION_ERROR, QUOTATION_SAVED } from '../Actions/Quotation.action';

const defaultState = {
    quotations: [],
    isSaved: false,
    error: false,
}

export const quotation = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case QUOTATION_RECEIVE:
        case QUOTATION_SAVED:
            return {
                ...state,
                ...payload,
            };
        case QUOTATION_ERROR:
            return {
                ...state,
            }
        default:
            return state;
    }
}
